import React, { useEffect } from 'react';
import { Modal, Select } from 'antd';
import { useCreateNakshatramSubTemple } from '../../services/nakshatram/sub-temple/nakshatram-sub-temple.service.hook';
import { useGetSubTemples } from '../../services/sub-temple/sub-temple.service.hook';
import TmsRowVertical from '../../components/tms-customs/tms-row-vertical';

const TmsNakshatramSubTempleCreateModal = ({
  nakshatramId,
  isOpen,
  onClose,
  nakshatram,
}) => {
  const { data: subTemples } = useGetSubTemples(undefined, 1, 1000);
  const { mutate: createSubTemple, isPending: createLoading } =
    useCreateNakshatramSubTemple();

  const [selectedSubTempleIds, setSelectedSubTempleIds] = React.useState([]);

  useEffect(() => {
    if (!isOpen) {
      setSelectedSubTempleIds([]);
    }
  }, [isOpen]);

  const handleCreateTemple = () => {
    if (selectedSubTempleIds.length === 0) {
      return;
    }
    createSubTemple(
      {
        nakshatramId: nakshatramId,
        subTempleIds: selectedSubTempleIds,
      },
      {
        onSuccess: () => {
          onClose();
        },
      }
    );
  };

  return (
    <Modal
      destroyOnClose={true}
      title={`Assign Sub Temples to ${nakshatram?.name} Nakshatram`}
      open={isOpen}
      onOk={handleCreateTemple}
      onCancel={() => {
        onClose();
      }}
      okButtonProps={{ loading: createLoading }}
    >
      <TmsRowVertical
        data={{
          one: 'Sub Temples',
          two: (
            <Select
              mode='multiple'
              style={{ width: '100%' }}
              placeholder='Select Sub Temples'
              value={selectedSubTempleIds}
              onChange={(value) => setSelectedSubTempleIds(value)}
              options={subTemples?.items.map((temple) => ({
                label: `${temple.shortName} - ${temple.name}`,
                value: temple.id,
              }))}
            />
          ),
          justify: 'center',
          style: { width: '100%', padding: '10px 0px' },
        }}
      />
    </Modal>
  );
};

export default TmsNakshatramSubTempleCreateModal;
